
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 81 81","fill":"#fff","fill-rule":"evenodd","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('use',{attrs:{"xlink:href":"#performance","x":".5","y":".5"}}),_c('symbol',{attrs:{"id":"performance","overflow":"visible"}},[_c('path',{attrs:{"d":"M40 12.952c-14.857 0-27.048 12.19-27.048 27.048S25.142 67.047 40 67.047 67.047 54.857 67.047 40 55.047 12.952 40 12.952zm8.762 26.286C48.761 44 44.952 48 40 48s-8.762-3.809-8.762-8.762c0-4.762 3.809-8.762 8.762-8.762 2.667 0 4.952 1.143 6.476 3.048l16.571-6.476 1.143 2.667-15.81 8.762c.381.381.381.571.381.762zM40 0C17.905 0 0 17.905 0 40s17.905 40 40 40 40-17.905 40-40S62.095 0 40 0zm0 73.143c-18.286 0-32.952-14.857-32.952-32.952C7.048 21.905 21.905 7.238 40 7.238c18.286 0 32.952 14.857 32.952 32.952.19 18.095-14.667 32.952-32.952 32.952z","fill":"currentColor","stroke":"none"}})])])
          )
        }
      }
    